<template>
  <div>
    <div v-if="notLastSlide" class="content">
      <div class="title-wrapper">
        <div class="title" :class="{ sized: hasLinkedEntity }">
          {{ title }}
        </div>
        <div
          v-if="hasLinkedEntity"
          class="linked-content"
          @click="$emit('reach-content')"
        >
          {{ $t('mayday-web.urgent-notification.linked-content') }}
          <font-awesome-icon
            class="redirect-icon"
            :icon="['fal', 'external-link']"
          />
        </div>
      </div>
      <mayday-editor
        :key="slideNbr"
        class="message"
        ref="editor"
        :editable="false"
        v-model="body"
        @click:open-link="handleOpenLink"
      />
    </div>
    <div v-else class="content reset-wrapper">
      <div class="title">
        {{ $t('mayday-web.urgent-notification.slide.all-read') }}
      </div>
      <base-button
        class="reset-btn"
        type="primary"
        size="sm"
        @click="$emit('reset')"
      >
        <font-awesome-icon :icon="['fal', 'undo']" />{{
          $t('mayday-web.urgent-notification.slide.reread')
        }}
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'urgent-notification-slide',
  props: {
    slideNbr: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    hasLinkedEntity: {
      type: Boolean,
      default: false,
    },
    notLastSlide: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      body: this.message,
    };
  },
  methods: {
    handleOpenLink({ href }) {
      window.open(href, '_blank');
    },
  },
  watch: {
    message(val) {
      this.body = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 65.5px;
  line-height: 19.2px;
  padding: 0px 24px;
  overflow: auto;
  transition: all 0.2s linear;

  .title-wrapper {
    display: flex;
    align-items: flex-end;
    gap: 6px;
    justify-content: between;
    margin-bottom: 4px;
    min-width: 0;
  }

  .title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 700;
    &.sized {
      width: calc(70vw - 250px);
    }
  }

  .message {
    padding: 0;
  }

  .linked-content {
    flex: none;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 700;
    color: $red-mayday;
    line-height: 14.4px;
    cursor: pointer;
  }
}

.reset-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.reset-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 14.4px;
  font-weight: 700;
  border-radius: 2px;
  border: none;
  margin-top: 8px;
}
</style>
